import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const FEATURE_FLAGS = {
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords -- feature flag name, not a credential
    PASSWORD_LOGIN_DISABLED: 'ss.email.login.disabled',
    PURCHASE_DISABLED: 'ecom.checkout.disabled',
    RATE_PLAN_CHANGE_DISABLED_MIGRATED: 'ss.rate.plan.change.button.migrated.disabled',
    MIGRATION_ACTIONS_DISABLED: 'ss.subscription.migration.actions.disabled',
};

export const API = {
    HYBRIS_CONFIGURATION: '/api/v1/{segment}/configuration/{configProperty}',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.HYBRIS_CONFIGURATION = '/api/hybris-configuration/{configProperty}';
}
